import styled from 'styled-components';

export { SwitchComponent } from './styles';

export const SwitchField = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  min-height: 32px;
  margin-bottom: 12px;
  white-space: nowrap;
`;

export const StackedColumns = styled.div`
  .ant-row {
    margin: 0 !important;
  }

  .ant-col {
    flex: 0 0 100%;
    max-width: 100%;
    padding: 0 !important;
  }
`;
